import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllRoadmaps: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.footer.view-all-roadmaps',
		defaultMessage: 'View all roadmaps',
		description: 'Message for the view all roadmaps menu item in the roadmaps submenu',
	},
});
